exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.searched {\n\tbackground-color: #00a09d57;\n}\n", ""]);

// exports
